import { styled } from '@/stitches.config';
import { useEffect, useRef, useState } from 'react';

type MetadataProps = {
  title: string;
  subtitle: string;
};

export function DesktopMetadata({ title, subtitle }: MetadataProps) {
  const [descriptionHeight, setDescriptionHeight] = useState<number>(0);
  const descriptionRef = useRef<HTMLDivElement>(null);

  function resetDescriptionHeight() {
    if (descriptionRef.current) {
      setDescriptionHeight(descriptionRef.current.offsetHeight + 9);
    }
  }

  useEffect(() => {
    resetDescriptionHeight();
    window.addEventListener('resize', resetDescriptionHeight);
    return () => window.removeEventListener('resize', resetDescriptionHeight);
  }, []);

  return (
    <MetadataWrapper
      css={{
        '--descriptionHeight': `${descriptionHeight + 28}px`,
      }}
    >
      <ProjectTitle>{title}</ProjectTitle>
      <ProjectDescription ref={descriptionRef}>{subtitle}</ProjectDescription>
    </MetadataWrapper>
  );
}

export const MetadataWrapper = styled('div', {
  color: 'white',
  padding: '$5',
  transition: 'transform 300ms ease-out',
  transform: 'translateY(var(--descriptionHeight))',
  textShadow: '1px 1px 1px rgba(0,0,0,0.1)',
});

const ProjectTitle = styled('h3', {
  capSize: 3,
  fontWeight: '$normal',
  marginBottom: '$6',
});

const ProjectDescription = styled('p', {
  color: '#fff', // White text, no need for theming
  capSize: 2,
  marginBottom: '$4',
});
